import { ControlProperty, ControlStringProperty, UserBaseModel } from '../../../../../common/models';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  EMAIL_PATTERN,
  Language,
  PASSWORD_PATTERN,
  VALIDATION_RULES,
  TimezoneTypeEnum,
  UnitSystem,
} from '../../../../../common/constants';
import { CountryCodes, mustNotBeBlankValidator, NO_SPACE_INBETWEEN_PATTERN } from '../../../../../common';
import { UserOwner, UserOwnerForm, UserOwnerType, UserRolesModel } from '../../user';
import { ProfileEstimatedDeliveryDateTypeEnum, ProfileShipmentViewMode } from '../constants';

export class ProfileModel extends UserBaseModel {
  owner: UserOwner = new UserOwner({ type: UserOwnerType.Organization });
  newsSubscribed = false;
  previousLogin: number;

  constructor(params?: ProfileModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ProfileResponseModel {
  profile: ProfileModel;
  token: string;
}

export class ProfileForm {
  constructor(
    model: ProfileModel,
    public email: ControlProperty<string> = [
      {
        value: model.email,
        disabled: true,
      },
      [Validators.required, Validators.pattern(EMAIL_PATTERN)],
    ],
    public firstName: ControlProperty<string> = [model.firstName, [Validators.required, mustNotBeBlankValidator]],
    public lastName: ControlProperty<string> = [model.lastName, [Validators.required, mustNotBeBlankValidator]],
    public defaultLanguage: ControlProperty<Language> = [model.defaultLanguage, [Validators.required]],
    public department: ControlProperty<string> = [model.department, []],
    public country: ControlStringProperty = [
      {
        value: model.country,
        disabled: model.country === CountryCodes.CN,
      },
      [Validators.required],
    ],
    public newsSubscribed: ControlProperty<boolean> = [model.newsSubscribed, []],
    public timezone: ControlProperty<string> = [model.timezone, [Validators.required]],
    public twentyFourHourTime: ControlProperty<boolean> = [model.twentyFourHourTime, [Validators.required]],
    public previousLogin: ControlProperty<number> = [{ value: model.previousLogin, disabled: true }, []],
    public renderTimezone: ControlProperty<TimezoneTypeEnum> = [model.renderTimezone, []],
    public owner: UntypedFormGroup = new UntypedFormBuilder().group(
      new UserOwnerForm(model.owner, model.owner.type === UserOwnerType.Organization),
    ),
    public masterOfRolesAssignedRoles: ControlProperty<UserRolesModel> = [
      model.masterOfRolesAssignedRoles as UserRolesModel,
      [Validators.required],
    ],
    public unitSystem: ControlProperty<UnitSystem> = [model.unitSystem, [Validators.required]],
    public estimatedDeliveryDateType: ControlProperty<ProfileEstimatedDeliveryDateTypeEnum> = [
      model.estimatedDeliveryDateType,
      [Validators.required],
    ],
    public defaultShipmentViewMode: ControlProperty<ProfileShipmentViewMode> = [
      model.defaultShipmentViewMode,
      [Validators.required],
    ],
    public includeDeliveryDateInShipmentView: ControlProperty<boolean> = [model.includeDeliveryDateInShipmentView, []],
    public includeMaterialsInShipmentView: ControlProperty<boolean> = [model.includeMaterialsInShipmentView, []],
  ) {}
}

export class ChangePasswordModel {
  confirmNewPassword = '';
  newPassword = '';
  oldPassword = '';

  constructor(params?: ChangePasswordModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ChangePasswordForm {
  constructor(
    model: ChangePasswordModel,
    public newPassword: FormControl<string | null> = new FormControl(model.newPassword, [
      Validators.required,
      Validators.pattern(PASSWORD_PATTERN),
      Validators.pattern(NO_SPACE_INBETWEEN_PATTERN),
    ]),
    public oldPassword: FormControl<string | null> = new FormControl(model.oldPassword, [
      Validators.required,
      Validators.minLength(VALIDATION_RULES.password.minLength),
      mustNotBeBlankValidator,
    ]),
    public confirmNewPassword: FormControl<string | null> = new FormControl(model.confirmNewPassword, [
      Validators.required,
      Validators.pattern(PASSWORD_PATTERN),
      Validators.pattern(NO_SPACE_INBETWEEN_PATTERN),
    ]),
  ) {}
}
